<script setup>
import Hero from '@/components/Hero.vue'
import Sidebar from '@/components/Sidebar.vue'
import Slider from '@/components/Slider.vue'
import Equipment from '@/components/Equipment.vue'
import HomeSections from '@/components/HomeSections.vue'
import { ref } from 'vue'
import Cookies from 'js-cookie'

const showBanner = ref(!Cookies.get('cookie_consent')) // Show banner if no consent cookie

// Handle accepting cookies
const acceptCookies = () => {
  Cookies.set('cookie_consent', 'accepted', { expires: 365 })
  showBanner.value = false
}
</script>

<template>
  <div>
  <Hero />

  <div class="hidden md:block w-full px-3 py-6">
    <div class="grid grid-cols-12 gap-4">
      <!-- Sidebar Section -->
      <aside class="col-span-2 bg-theme-bg2 rounded-xl p-2">
        <Sidebar />
      </aside>

      <!-- Main Content Section -->
      <main class="col-span-10">
        <Slider />
        <Equipment :isPreview="true" />
      </main>
    </div>
  </div>

  <div class="px-4 py-2 md:hidden">
    <Equipment :isPreview="true" />
  </div>

  <!-- ─── Additional Homepage Sections ─── -->
  <HomeSections />
  
  <!-- Privacy Banner -->
  <div v-if="showBanner" class="fixed bottom-0 left-0 w-full bg-theme-nav text-theme-text p-4 z-50">
    <div class="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center">
      <div>
        <h3 class="text-lg font-semibold">We Value Your Privacy</h3>
        <p class="text-sm mt-2">
          This website uses cookies to enhance your experience. By continuing to use this site, you agree to our use of cookies.
          <a
            href="/privacy-cookie-notice"
            class="underline text-secondary-500 hover:text-secondary-600"
          >
            Learn more.
          </a>
        </p>
      </div>
      <div class="mt-4 md:mt-0 flex space-x-4">
        <button
          @click="acceptCookies"
          class="bg-primary-600 hover:bg-primary-700 text-white px-4 py-2 rounded-md font-medium"
        >
          Accept
        </button>
      </div>
    </div>
  </div>
  </div>
</template>

<style scoped>
a {
  transition: color 0.3s ease;
}
</style>
